<template>
  <section class="py-16 md:py-24 px-6 md:px-12 lg:px-24">
    <!-- العنوان الأساسي في أعلى القسم -->
    <h2 class="text-5xl md:text-6xl lg:text-5xl font-black text-[#39ab58] text-center mb-12">
      {{ $t('we-are.title') }}
    </h2>

    <div class="container mx-auto flex flex-col md:flex-row gap-12 md:gap-16 lg:gap-24 items-center">
      <!-- الجانب الأيسر - المحتوى النصي -->
      <div :class="[
        'flex flex-col justify-center md:w-1/2 border border-gray-300 rounded-lg shadow-lg p-6 transition-all duration-300 hover:ring-1 ring-[#22c55e]',
        { 'order-1 md:order-none': $i18n.locale === 'ar' }
      ]">
        <!-- العنوان الثانوي -->
        <span class="text-[#346bb3] lg:text-3xl md:text-base font-bold mb-4">
          {{ $t('we-are.whatWeDo.title') }}
        </span>

        <!-- الوصف -->
        <p class="text-gray-600 text-base md:text-lg leading-relaxed max-w-2xl">
          {{ $t('we-are.whatWeDo.description') }}
        </p>
      </div>

      <!-- الجانب الأيمن - الصور -->
      <div class="grid grid-cols-2 gap-6 md:gap-8 self-center h-full md:w-1/2">
        <!-- الصورة الأولى -->
        <div class="relative rounded-xl overflow-hidden shadow-lg">
          <img src="../assets/img/HARDWIRE-KIT.webp" :alt="$t('we-are.images.team')"
            class="w-full h-full object-cover transition-all duration-300 hover:scale-105" />
        </div>

        <!-- الصورة الثانية -->
        <div class="">
          <img src="../assets/img/fmb120Device.webp" :alt="$t('we-are.images.office')"
            class="w-full rounded object-cover transition-all duration-300 hover:scale-105" />
        </div>
      </div>
    </div>
  </section>

  <section class="px-6 md:px-12 lg:px-24">
    <div class="container mx-auto flex flex-col md:flex-row gap-12 md:gap-16 lg:gap-24 items-center">
      <!-- الجانب الأيسر - الصورة -->
      <div :class="[
        'flex justify-center items-center md:w-1/2 h-full',
        { 'order-1 md:order-none': $i18n.locale === 'ar' }
      ]">
        <div class="relative rounded-xl overflow-hidden w-4/5 md:w-3/4 h-full">
          <img src="../assets/img/fmb120.webp" :alt="$t('we-are.images.team')"
            class="w-5/6 h-4/5 object-cover transition-all duration-300 hover:scale-105" />
        </div>
      </div>

      <!-- الجانب الأيمن - المحتوى النصي -->
      <div
        class="flex flex-col justify-center md:w-1/2 border border-gray-300 rounded-lg shadow-lg p-6 h-full transition-all duration-300 hover:ring-1 ring-[#22c55e]">
        <!-- العنوان الثانوي -->
        <span class="text-[#346bb3] lg:text-3xl md:text-base font-bold mb-4">
          {{ $t('we-are.benefits.title') }}
        </span>

        <!-- الوصف -->
        <p class="text-gray-600 text-base md:text-lg leading-relaxed max-w-2xl">
          {{ $t('we-are.benefits.description') }}
        </p>
      </div>
    </div>
  </section>

  <br /><br />

  <div class="hidden md:block self-stretch divider-gradient"></div>
</template>

<script>
export default {
  name: "we-areSection",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap');

[dir="ltr"] h2,
[dir="ltr"] span,
[dir="ltr"] p {
  font-family: "Poppins", sans-serif;
}

[dir="rtl"] h2,
[dir="rtl"] span,
[dir="rtl"] p {
  font-family: "Cairo", sans-serif;
}

h2,
span {
  font-weight: 700;
}

p {
  font-weight: 400;
}

.divider-gradient {
  height: 22px;
  background: linear-gradient(90deg,
      rgba(162, 205, 222, 0) 0%,
      rgba(162, 205, 222, 1) 20%,
      rgba(215, 234, 236, 1) 49%,
      rgba(195, 230, 205, 1) 75%,
      rgba(195, 230, 205, 0) 100%,
      rgba(214, 234, 238, 1) 753%);
  width: 70%;
  margin: 0 auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  filter: blur(3px);
}

[dir="rtl"] .divider-gradient {
  transform: scaleX(-1);
}

@media (max-width: 768px) {
  .divider-gradient {
    display: block;
  }
}
</style>